const globalConfig = {
  methods: {
    async loadGlobalConfigFromFile() {
      // Config is already loaded via Vuex (store.commit("setConfig")) in main.js before the app mounts.
    },
  },
  computed: {
    config_HideOtherTargetGroups() {
      return this.$store.state.auth.config?.HideOtherTargetGroups ?? false;
    },
    config_WebApiUrl() {
      return this.$store.state.auth.config?.WebApiUrl || "";
    },
    config_JwtTokenExpiry() {
      return this.$store.state.auth.config?.JwtTokenExpiry || "";
    },
    config_GoogleTagId() {
      return this.$store.state.auth.config?.GoogleTagId || "";
    },
    config_BackgroundColor() {
      return this.$store.state.auth.config?.BackgroundColor || "";
    },
    config_ApplicationHeading() {
      return this.$store.state.auth.config?.ApplicationHeading || "";
    },
    config_ApplicationHeadingVideoInHome() {
      return this.$store.state.auth.config?.ApplicationHeadingVideoInHome || "";
    },
    config_ApplicationSubHeading() {
      return this.$store.state.auth.config?.ApplicationSubHeading || "";
    },
    config_ApplicationSubHeadingVideoInHome() {
      return this.$store.state.auth.config?.ApplicationSubHeadingVideoInHome || "";
    },
    config_LinkOnlineAnalys() {
      return this.$store.state.auth.config?.LinkOnlineAnalys || "";
    },
    config_LinkTotalanalys() {
      return this.$store.state.auth.config?.LinkTotalanalys || "";
    },
    config_LinkDataPortal() {
      return this.$store.state.auth.config?.LinkDataPortal || "";
    },
    config_MiniumClientVersion() {
      return this.$store.state.auth.config?.MiniumClientVersion || "";
    },
    config_CurrentClientVersion() {
      return this.$store.state.auth.config?.CurrentClientVersion || "";
    },
    config_AppCookieDomain() {
      return this.$store.state.auth.config?.AppCookieDomain || "";
    },
    config_AppCookieDomainVideoInHome() {
      return this.$store.state.auth.config?.AppCookieDomainVideoInHome || "";
    },
    config_AuthCookieDomain() {
      return this.$store.state.auth.config?.AuthCookieDomain || "";
    },
    config_AnalyzeRowsToRofLimit() {
      return this.$store.state.auth.config?.AnalyzeRowsToRofLimit || "";
    },
    config_WebCaatAuthWebUrl() {
      return this.$store.state.auth.config?.WebCaatAuthWebUrl || "";
    },
    config_ShowGroupByDropdowns() {
      return this.$store.state.auth.config?.ShowGroupByDropdowns;
    },
    config_ShowStreamingTab() {
      return this.$store.state.auth.config?.ShowStreamingTab;
    },
    config_ShowVideoInHomeAsTabInTvAnalys() {
      return this.$store.state.auth.config?.ShowVideoInHomeAsTabInTvAnalys;
    },
    config_NumberOfTargetGroups() {
      return this.$store.state.auth.config?.NumberOfTargetGroups || "";
    },
    config_ShowChannelRadioButtons() {
      return this.$store.state.auth.config?.ShowChannelRadioButtons;
    },
    config_ShowSaveSearchButton() {
      return this.$store.state.auth.config?.ShowSaveSearchButton;
    },
    config_ShowTargetDevices() {
      return this.$store.state.auth.config?.ShowTargetDevices;
    },    
    config_LinkTvAnalys() {
      return this.$store.state.auth.config?.LinkTvAnalys || "";
    },
    config_LinkVideoInHome() {
      return this.$store.state.auth.config?.LinkVideoInHome || "";
    },
  },
};

export default globalConfig;
